import { all, fork } from 'redux-saga/effects';
import watchInitialDataFetching from './watchInitialDataFetching';
import watchInitialDataLoading from './watchInitialDataLoading';

export default function* watchLoggedIn() {
  yield all([fork(watchInitialDataFetching), fork(watchInitialDataLoading)]);
}
